const googleMapsKey = 'AIzaSyDrzzovfYyMzTgPUza6KWEvgOFqesFJMtI';

const config = {
  env: 'DEV',
  geolocationAPI: `https://www.googleapis.com/geolocation/v1/geolocate?key=${googleMapsKey}`,
  appMode: process.env.appMode,
  apiUrlV2: 'https://internal-api-staging.fleetops.ai:5055/v1', // Staging V2
  firebaseConfig: {
    apiKey: 'AIzaSyDVLwOfPWL9iUEtExjTDT8k1LgydQzIzeA',
    authDomain: 'fleetops.ai',
    databaseURL: 'https://fleetops-p.firebaseio.com',
    projectId: 'fleetops-p',
    storageBucket: 'fleetops-p.appspot.com',
    messagingSenderId: '326879692618',
  },
  googleTagManager: {
    gtmId: 'GTM-54PL85J', // FleetOps-Staging-Application account
  },
  mixpanelConfig: {
    token: '21ea7debd2895a6d6f125a49aed73bcc',
  },
  googleMapsKey,
  staticGoogleMapsURL: 'https://maps.googleapis.com/maps/api/staticmap?',
};

export default config;
